/**
 * Hosts considerados productivos para herramientas internas del admin. Se usa
 * para ocultar acciones que solo deben estar disponibles en dev/QA/local
 * (ej. "Forzar envío Lups" desde /admin/cobros). El backend valida lo mismo
 * por `req.hostname` — esto es la primera línea de defensa en la UI.
 */
const PROD_HOSTS = new Set(['app.goflux.io']);

export function isProduction(): boolean {
  if (typeof window === 'undefined') return true;
  return PROD_HOSTS.has(window.location.hostname);
}
